import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";
import banner from "../../assets/banner.png";
import contact from "../../assets/contact.png";
import gift from "../../assets/gift.webp";
import sales from "../../assets/sales.jpg";
import versace from "../../assets/versace.jpg";
import women from "../../assets/women.jpeg";
import hero_1 from "../../assets/hero-1.png";
import hero_2 from "../../assets/hero-2.png";

import { useLocation, useNavigate } from "react-router-dom";
import { Buttons } from "../Buttons";
import Navbar from "../Navbar";
import { Helmet } from "react-helmet-async";

export function Banner({ Title, secttile, dec1, dec2, img, height }) {
  const title1Ref = useRef(null);
  const blueWaterRef = useRef(null); // Separate ref for Blue Water
  const fragrancesRef = useRef(null); // Separate ref for Fragrances
  const imageRef = useRef(null);
  const descRef = useRef(null);
  const buttonRef = useRef([]);
  const location = useLocation();
  const isHome = location.pathname === "/";
  const navigate = useNavigate();

  const [current, setCurrent] = React.useState(0);
  const bannerImages = [hero_1, hero_2, contact, gift, sales, versace, women];
  React.useEffect(() => {
    if (!isHome) return;
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % bannerImages.length);
    }, 3000); // 5 seconds
    return () => clearInterval(interval);
  }, [isHome]);

  const handleGoHome = () => {
    navigate("/fragrance"); // Redirects to Home page
  };

  useEffect(() => {
    const tl = gsap.timeline();

    // Blue Water animation
    tl.from(blueWaterRef.current, {
      opacity: 0,
      scale: 0.95,
      duration: 1.2,
      ease: "power2.out",
    });

    // Fragrances animation
    tl.from(
      fragrancesRef.current,
      {
        opacity: 0,
        y: 40,
        duration: 1,
        ease: "power3.out",
      },
      "-=0.7",
    ); // overlap with previous

    // Image animation
    tl.from(
      imageRef.current,
      {
        y: 100,
        opacity: 0,
        duration: 1.5,
        ease: "power2.out",
      },
      "-=1",
    ); // overlap slightly

    // Title1 animation
    tl.from(
      title1Ref.current,
      {
        y: 100,
        opacity: 0,
        scale: 0.95,
        duration: 1,
        ease: "power3.out",
      },
      "-=1",
    ); // overlap

    // Description animation
    tl.from(
      descRef.current,
      {
        y: 40,
        opacity: 0,
        duration: 1,
        ease: "power3.out",
      },
      "-=0.8",
    );

    tl.fromTo(
      buttonRef.current[0],
      { y: 40, opacity: 0 },
      { y: 0, opacity: 1, duration: 1, ease: "power3.out" },
      "-=0.8",
    );
  }, []);

  return (
    //  {isHome ? }
    <div
      className={`banner-start h-[${height}] px-[1rem] bg-cover bg-center bg-no-repeat relative`}
      // style={{
      //   backgroundImage: `
      //     linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)),
      //     url(${img})
      //   `,
      // }}
    >
      {isHome ? (
        // Slider logic
        bannerImages.map((image, index) => (
          <div
            key={index}
            className={`absolute top-0 left-0 w-full h-full bg-cover bg-center transition-opacity duration-1000 ${index === current ? "opacity-100" : "opacity-0"}`}
            style={{
              backgroundImage: `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)),
          url(${image})`,
            }}
          ></div>
        ))
      ) : (
        // Static single image for other routes
        <div
          className="absolute top-0 left-0 w-full h-full bg-cover bg-center"
          style={{
            backgroundImage: `
           linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)),
          url(${img})
         `,
          }}
        ></div>
      )}
      {/* <Navbar /> */}
      <div className="flex flex-col justify-center items-center h-[100vh] text-center relative z-[1]">
        <div className="relative z-[1] mt-[-10rem] lg:mt-[-20rem]">
          <h2
            ref={blueWaterRef}
            className="font-syne font-bold text-[2.4rem] sm:text-5xl md:text-6xl lg:text-8xl text-white"
            style={{
              textShadow: `
                1px 0 0 white,
                -1px 0 0 white,
                0 1px 0 white,
                0 -1px 0 white
              `,
            }}
          >
            {Title}
          </h2>

          <h2
            ref={fragrancesRef}
            className="font-syne mt-[1rem] font-bold text-[2.8rem] sm:text-6xl md:text-7xl lg:text-9xl text-white"
            style={{
              textShadow: `
                1px 0 0 white,
                -1px 0 0 white,
                0 1px 0 white,
                0 -1px 0 white
              `,
            }}
          >
            {secttile}
          </h2>
        </div>

        <div className="relative z-[1]">
          <div
            ref={title1Ref}
            className="text-white font-light font-outfit text-1xl text-center lg:text-start mt-4 w-[100%] sm:w-[400px] lg:absolute lg:top-[0px] lg:right-[50px] lg:transform lg:-translate-x-1/2"
            style={{
              transform: "translate(0%, 0%) rotate(0deg) scale(1)",
              opacity: 1,
            }}
          >
            <p className="text-center"> {dec1} </p>
          </div>

          <div className="lg:absolute lg:bottom-[-100px] lg:left-1/2 transform lg:-translate-x-[-100%] transform lg:-translate-y-[-100%] w-[100%] sm:w-[400px] text-white font-outfit text-center lg:text-start mt-4">
            <p
              ref={descRef}
              className="text-base font-light leading-relaxed pb-[2rem] "
            >
              {dec2}
            </p>

            <div className="flex justify-center lg:justify-start w-full">
              <Buttons
                title={"Shop Now"}
                handleClick={handleGoHome}
                ref={(el) => (buttonRef.current[0] = el)}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export const NewBanner = ({ image }) => {
  return (
    <>
      {/* Banner Desing Here */}
      <div className="w-full ">
        <div className="w-full flex justify-center items-center relative">
          {/* Poster Image */}
          <img
            src={image}
            alt={`banner`}
            className="w-full  h-auto md:h-[100vh] object-contain md:object-fill transition-transform duration-500 ease-in-out "
          />
          {/* Glass/Dark overlay */}
          {/* <div className="absolute inset-0 bg-black bg-opacity-0 transition-opacity duration-500 hover:bg-opacity-50"></div> */}
        </div>
      </div>
    </>
  );
};
